import { render, staticRenderFns } from "./sfc-logo-desktop.vue?vue&type=template&id=5419c7f0&scoped=true&lang=pug&"
import script from "./sfc-logo-desktop.vue?vue&type=script&lang=js&"
export * from "./sfc-logo-desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419c7f0",
  null
  
)

export default component.exports